import { useEffect, useState } from "react"
import { H4 } from "components/ui/typography/titles/Titles"
import { EditDimensionsModal } from "./layout/EditDimensionsModal/EditDimensionsModal"
import type { TDimensions } from "types/modelNumbers.type"
import style from "./Dimensions.module.scss"

const { dimensionsStyle, topBlock, editButton, dimensionsBlock, dimensionsWrapper, dimensionItem, sizesBlock, gray } =
	style

type Props = {
	modelNumberId?: number
	dimensions: TDimensions
}

export const Dimensions = ({ modelNumberId, dimensions }: Props) => {
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [currentDimensions, setCurrentDimensions] = useState<TDimensions>(dimensions)

	useEffect(() => {
		setCurrentDimensions(dimensions)
	}, [dimensions])

	return (
		<>
			<div className={dimensionsStyle}>
				<div className={topBlock}>
					<H4>Dimensions</H4>
					<button className={editButton} onClick={() => setIsModalOpen(true)}>
						Edit
					</button>
				</div>
				<div className={dimensionsBlock}>
					<span>Width, in</span>
					<div className={dimensionsWrapper}>
						{currentDimensions.width.map((width) => (
							<div className={dimensionItem} key={width}>
								{width}
							</div>
						))}
					</div>
				</div>
				<div className={dimensionsBlock}>
					<span>Height, in</span>
					<div className={dimensionsWrapper}>
						{currentDimensions.height.map((height) => (
							<div className={dimensionItem} key={height}>
								{height}
							</div>
						))}
					</div>
				</div>
				<div className={dimensionsBlock}>
					<span>Depth, in</span>
					<div className={dimensionsWrapper}>
						{currentDimensions.depth.map((depth) => (
							<div className={dimensionItem} key={depth}>
								{depth}
							</div>
						))}
					</div>
				</div>
				<div className={sizesBlock}>
					<div className={dimensionsBlock}>
						<span>Min size, in3</span>
						<div className={`${dimensionItem} ${gray}`}>{currentDimensions.min_size}</div>
					</div>
					<div className={dimensionsBlock}>
						<span>Avg size, in3</span>
						<div className={dimensionItem}>{currentDimensions.avg_size}</div>
					</div>
					<div className={dimensionsBlock}>
						<span>Max size, in3</span>
						<div className={`${dimensionItem} ${gray}`}>{currentDimensions.max_size}</div>
					</div>
				</div>
			</div>
			<EditDimensionsModal
				modelNumberId={modelNumberId}
				dimensions={currentDimensions}
				isModalOpen={isModalOpen}
				setModalClose={() => setIsModalOpen(false)}
				onSave={setCurrentDimensions}
			/>
		</>
	)
}
